import {createSlice} from '@reduxjs/toolkit'

const dataTemplate = {
  loading: false,
  error: '',
  data: [],
  init: false
};

const initialState = {
  myAddress: {
    data: [],
    updated: true,
    init: false
  },
  popup: {},
  provinces: dataTemplate,
  cities: {template: dataTemplate},
  areas: {template: dataTemplate},
  address: {}
}

const addressSlice = createSlice({
  name: 'address',
  initialState: initialState,
  reducers: {
    tryPostNewAddress: (state, action) => {},
    setAddAddressPopupOpened(state, action) {
      state.popup.edit = action.payload.address ?? (action.payload.close ? undefined : {});
    },
    setProvinces(state, action) {
      if (action.payload.error) {
        state.provinces.error = action.payload.error
        state.provinces.loading = false
      } else if (action.payload.provinces) {
        state.provinces.data = action.payload.provinces
        state.provinces.loading = false
        state.provinces.init = true

      } else {
        state.provinces.error = ""
        state.provinces.loading = action.payload.loading ?? true
      }
    },
    setCitiesAndAreas(state, action) {
      if (action.payload.error) {
        state[action.payload.element][action.payload.id].error = action.payload.error
        state[action.payload.element][action.payload.id].loading = false
      } else if (action.payload.data) {
        state[action.payload.element][action.payload.id].data = action.payload.data
        state[action.payload.element][action.payload.id].loading = false
        state[action.payload.element][action.payload.id].init = true

      } else {
        if (!state[action.payload.element][action.payload.id]) {
          state[action.payload.element][action.payload.id] = {...initialState[action.payload.element].template};
        }
        state[action.payload.element][action.payload.id].error = ""
        state[action.payload.element][action.payload.id].loading = action.payload.loading ?? true
      }
    },
    updateAddress: (state, action) => {
      const {
        addressData,
        isUpdate,
        shouldNotify
      }= action.payload

      if (isUpdate) {
        //if the modified address is default address, bring it to top, remove any existing default address

        state.myAddress.data = state.myAddress.data.reduce((acc, current) => {
          return addressData.id === current.id ? addressData.default_address ? [addressData, ...acc] :
            [...acc, addressData] : [...acc, addressData.default_address ? {
            ...current,
            default_address: false
          } : current]
        }, [])
        if (shouldNotify) {
          state.myAddress.updated = !state.myAddress.updated;
        }
        // if (state.myAddress.selectedAddress?.id === addressData.id){
        //   state.myAddress.selectedAddress = addressData;
        // }else if(addressData.default_address && state.myAddress.selectedAddress){
        //   state.myAddress.selectedAddress = {...state.myAddress.selectedAddress, default_address: false}
        // }

      } else {

        if (!state.myAddress.data.length && !state.myAddress.selectedAddressId) {
          state.myAddress.selectedAddressId = addressData.id;
        }

        //case if the newly added is default bring it to the top and remove existing default address, if not insert it to the 2nd position after default address
        state.myAddress.data = state.myAddress.data.length ? addressData.default_address ? [addressData, ...state.myAddress.data.map((add) => ({
          ...add,
          default_address: false
        }))] : state.myAddress.data.reduce((acc, current) => current.default_address ?
          [...acc, current, addressData] : [...acc, current], []) : [addressData]
      }
    },
    selectAddress: (state, action) => {
      state.myAddress.selectedAddressId = action.payload.addressId ?? state.myAddress.data.find(add => add.default_address)?.id;
    },
    tryRemoveAddress: (state, action) => {
    },
    tryAddOrUpdateAddress: (state, action) => {
    },

    tryFetchProvinces: () => {
    },
    tryFetchCitiesAndAreas: (state, action) => {
    },
    setAddress: (state, action) => {
      state.address = action.payload ?? {};
    }
  }
})


export const {
  tryPostNewAddress,
  tryFetchProvinces,
  setProvinces,
  updateAddress,
  tryRemoveAddress,
  tryFetchCitiesAndAreas,
  setCitiesAndAreas,
  setAddress,
} = addressSlice.actions

export default addressSlice.reducer




